//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FreelancerProfileTabs from '@/components/freelancer/FreelancerProfileTabs'
import InviteButton from '@/components/client/InviteButton'
import Paper from '@/components/ui/Paper'
import InviteToJobModal from '@/components/client/InviteToJobModal'
import BasicInfoPreview from '@/components/profile/BasicInfoPreview'
import SeoMethods from '@/mixins/SeoMethods'

export default {
  name: 'FreelancerProfile',
  components: {
    FreelancerProfileTabs,
    InviteButton,
    Paper,
    InviteToJobModal,
    BasicInfoPreview
  },
  mixins: [SeoMethods],
  props: {
    freelancer: {
      type: Object,
      required: true
    }
  },
  head () {
    const profile = this.freelancer
    let title = null
    let b = null
    let a = null

    if (profile) {
      const {
        name,
        location,
        countryId,
        bio,
        avatar,
        occupation
      } = profile
      const country = this.countries ? this.countries[countryId] : null
      title = name

      if (occupation) {
        title += ` - ${occupation}`
      }

      if (location || country) {
        title += ` ${this.$t('common.from')} `
      }

      if (location) {
        title += `${location}`
      }

      if (country && location) {
        title += ', '
      }

      if (country) {
        title += `${country.name}`
      }

      b = bio
      a = avatar
    }

    return this.buildTags(title, b, a, null, '%s')
  },
  computed: {
    /**
     * Is user logged in
     * @return {Boolean}
     */
    loggedIn () {
      return this.$auth.loggedIn
    },

    isClient () {
      return this.$store.getters['user/isClient']
    },

    isAgent () {
      return this.$store.getters['user/isAgent']
    },

    client () {
      return this.$store.getters['user/getClient']
    },

    isSameUser () {
      return this.freelancer?.userId === this.client?.userId
    },

    showInvite () {
      return !this.loggedIn || (this.loggedIn && !this.isSameUser && (this.isClient || this.isAgent))
    },

    countries () {
      return this.$store.getters['util/getCountriesMap']
    }
  },
  methods: {
    /**
     * Open invite modal
     */
    openInviteModal () {
      if (this.loggedIn) {
        this.$refs['invite-job-modal'].showModal()
      } else {
        this.$router.push(this.localePath('/login'))
      }
    },

    /**
     * Skill tag is clicked
     * Set skill and category and move to freelancers page
     * @param $event
     */
    async skillClicked ($event) {
      await this.$store.dispatch('freelancers/setSkillCategory', $event)
      await this.$router.push(this.localePath('/freelancers'))
    }
  }
}
